/* eslint jsx-a11y/href-no-hash: "off" */
import React from "react";
import Skins from "../_data/Skins.js";
import {
  getNextSkin,
  changeEditingCombatantValue
} from "./edit-combatant-operations";

class EditCombatantAppearance extends React.Component {
  //These bits of functionality may end up getting converted to MenuOptions if we use a Menu instance here.
  //(for keyboarding)
  handleNextClick(e) {
    e.preventDefault();
    changeEditingCombatantValue(
      "combatantSkin",
      getNextSkin(this.props.combatantSkin, "next")
    );
  }
  handlePrevClick(e) {
    changeEditingCombatantValue(
      "combatantSkin",
      getNextSkin(this.props.combatantSkin, "prev")
    );
  }

  render() {
    const groupStyle = {
      marginBottom: "1em"
    };
    // const labelStyle = {
    //   fontSize: "0.8em",
    //   display: "block",
    //   textAlign: "center",
    //   color: "#9D91A4"
    // };
    const rowStyle = {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center"
    };
    const imageContainerStyle = {
      width: "9em",
      height: "9em",
      position: "relative"
    };
    const imageStyle = {
      position: "absolute",
      width: "100%",
      left: 0,
      top: 0
    };

    const skinModel = Skins()[this.props.combatantSkin];

    return (
      <div style={groupStyle}>
        {/*<label style={labelStyle}>Appearance</label>*/}
        <div style={rowStyle}>
          <a
            className="button small"
            href="#"
            onClick={this.handlePrevClick.bind(this)}
          >
            <span className="button--text button--text_left-arrow-nudge">
              {"<"}
            </span>
          </a>
          <div style={imageContainerStyle}>
            <img
              style={imageStyle}
              src="/images/misc/shadow.svg"
              alt="Shadow"
            />
            <img style={imageStyle} src={skinModel.frontViewSrc} alt="Shadow" />
          </div>
          <a
            className="button small"
            href="#"
            onClick={this.handleNextClick.bind(this)}
          >
            <span className="button--text button--text_right-arrow-nudge">
              {">"}
            </span>
          </a>
        </div>
      </div>
    );
  }
}

export default EditCombatantAppearance;



// WEBPACK FOOTER //
// ./src/b5-crew-management/EditCombatantAppearance.js